export const formatMiles = (miles: number) => {
  return miles.toLocaleString("en-US");
};

export const formatMilesCompact = (miles: number) => {
  if (miles < 1000) {
    return miles.toString();
  } else if (miles < 1000000) {
    return (miles / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  } else if (miles < 1000000000) {
    return (miles / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  } else {
    return (miles / 1000000000).toFixed(1).replace(/\.0$/, "") + "B";
  }
};
